<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="policy-child-doc">
        <h1 class="policy-child-doc__title">
            个人信息保护政策-毛豆系列应用产品
        </h1>
        <p class="policy-child-doc__p">
            本政策仅适用于高途教育科技集团有限公司（注册地址：北京市海淀区西北旺东路10号院东区7号楼1层W102。常用办公地址：北京市海淀区西北旺东路10号院东区17号楼文思海辉大厦）的毛豆系列应用产品（包含「毛豆爱古诗」、「毛豆爱阅读」、「毛豆爱成语」、「毛豆启蒙好课」、「毛豆乐读」、「毛豆爱学」等app在内，下称“我们”）。
        </p>
        <p class="policy-child-doc__meta">
            生效日期：2026年5月14日<br>最近更新日期：2026年5月7日
        </p>
        <p class="policy-child-doc__p">
            如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：
        </p>
        <p class="policy-child-doc__p">
            电子邮件：xuelu@gaotu.cn
        </p>
        <p class="policy-child-doc__p">
            电话：4000910188
        </p>
        <p class="policy-child-doc__p">
            本政策将帮助您了解以下内容：
        </p>
        <p class="policy-child-doc__p">
            1、我们如何保护您的个人信息
        </p>
        <p class="policy-child-doc__p">
            2、第三方SDK调用说明
        </p>
        <p class="policy-child-doc__p">
            3、您的权利
        </p>
        <p class="policy-child-doc__p">
            4、我们如何处理儿童的个人信息
        </p>
        <p class="policy-child-doc__p">
            5、您的个人信息如何在全球范围转移
        </p>
        <p class="policy-child-doc__p">
            6、本政策如何更新
        </p>
        <p class="policy-child-doc__p">
            7、如何联系我们
        </p>
        <p class="policy-child-doc__p">
            我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请在使用我们的产品或服务前，仔细阅读并了解本《个人信息保护政策》。
        </p>
        <p class="policy-child-doc__p">
            个人信息收集使用规则
        </p>
        <p class="policy-child-doc__p">
            1、我们收集哪些您的个人信息
        </p>
        <p class="policy-child-doc__p">
            （1）我们提供的业务功能需要依赖部分信息才得以运行。您选择使用该项业务功能，则需要向我们提供或允许我们收集的必要信息包括：用户名、手机号、性别、生日年月、年龄 共计5类个人信息，用于进行部分产品内功能，如学习报告、奖状等内容的信息展示。
        </p>
        <p class="policy-child-doc__p">
            （2）您可自主选择向我们提供或允许我们收集下列信息：相册、文件夹共计2类个人信息。这些信息并非该业务功能运行所必需，但这些信息对改善服务质量、研发新产品或服务有非常重要的意义。我们不会强制要求您提供这些信息，您如拒绝不会对使用该业务功能产生不利影响。
        </p>
        <p class="policy-child-doc__p">
            （3）在您使用该业务功能时，我们的App会向您申请下列与个人信息相关的系统权限：读取文件（用于下载和解压内容资源）、读取图片（用于进行头像更换功能）、上传文件（语音评测录音文件和最终作品）、录制音频（语音评测）、开启摄像头（读古诗环节中录制作品视频、视频拜年功能中录制作品）共计5项系统权限。如果您不授权，将会导致我们无法提供该业务功能。除上述权限之外，您可自主选择是否额外授予App其他的系统权限。当您授予“录制音频”权限并启动播放后，该权限在后台播放期间将持续有效以保证音频输出，但后台状态下不会进行任何录音操作。
        </p>
        <p class="policy-child-doc__p">
            （4）为了保障软件与服务的安全运行，对于安卓端app，我们产品（com.baijia.ei,com.baijiahulian.maodou）会收集硬件型号、AndroidID、操作系统版本号、国际移动设备识别码（IMEI）、唯一设备标识符（oaid）、网络设备硬件地址（mac地址）、IP地址、操作、使用、服务日志、ANDROID ID信息。我们可能会在应用前台运行时、应用后台运行时收集这些信息，并将这些信息进行关联，以便我们能够为您提供一致的服务。为了保障音频后台播放功能的正常使用，当您使用音频播放功能并切换到后台运行时，为维持播放稳定性，我们需持续获取设备运行状态（如网络连接、设备休眠状态），但不会额外收集您的音频内容或敏感信息。
        </p>
        <p class="policy-child-doc__p">
            （5）对于安卓端app，为改善及优化您的服务体验，同时出于统计和广告的目的，我们会通过火山引擎增长营销套件（GrowingIO SDK)收集您的设备信息（设备型号，操作系统，MAC地址，Android ID,已安装应用列表，OAID, 唯一设备标识符（包括IMEI)）。我们的产品集成听云SDK，听云SDK需要收集您的唯一设备识别码（Android系统 OAID）以提供统计分析服务。
        </p>
        <p class="policy-child-doc__p">
            （6）我们的产品为改善注册及登录界面用户体验，集成第三方SDK一键登录服务：闪验SDK，用于帮助实现用户一键登录行为。为了实现网关取号技术，闪验SDK需要获取IP地址、网卡（MAC)地址、国际移动设备识别码（IMEI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志数据以提供统计分析服务能力，并可提供反欺诈功能。
        </p>
        <p class="policy-child-doc__p">
            （7）对于安卓端用户，我们的产品为了帮助用户在客户端内使用微信支付，集成微信支付SDK服务，将获取设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、BSSID, SSID信息
        </p>
        <p class="policy-child-doc__p">
            （8）请您特别注意：某些第三方SDK还会收集您设备的MAC地址、IMEI号、BSSID, SSID;（但我们会要求我们的应用中接入的所有第三方SDK只能在您同意本政策后才能初始化和收集您的个人信息）
        </p>
        <p class="policy-child-doc__p">
            （9）当我们收集并使用这些信息实现上述功能时，我们通过动态弹窗征求您的同意，您可以选择同意或拒绝，当您选择同意即代表您授权我们收集并使用您的信息，当您选择拒绝即代表您未授权我们收集并使用您的信息，我们将不会收集和使用您的信息，也可能无法为您提供上述服务。
        </p>
        <p class="policy-child-doc__p">
            （10）您的个人信息的存储期限：为了便于进行相关问题追溯，您提供的所有个人信息的存储期限为收集日期开始的5年内，超出上述期限后，我们会对您的个人信息进行删除或匿名化处理。
        </p>
        <p class="policy-child-doc__p">
            （11）需要特别说明的是,为在安卓系统上稳定运行,我们会使用安卓官方推荐的音乐播放服务使用方式,即在系统资源紧张的时候使音乐播放服务被系统回收,待系统资源宽松后重新进入就绪状态。 您了解,在部分情况下该行为可能会被误判为应用自启动,但该行为属于合理使用并非侵犯用户权益的自启动行为。
        </p>
        <p class="policy-child-doc__p">
            （12）如果用户在后台播放出现卡顿/闪退等情况,用户可以在系统设置页中开启自启动权限,以提高我们在系统后台的活动优先级用于解决前述问题。 特别说明的是授予自启动权限后,我们只会用于提升后台播放稳定性,不会用于APP自启动。
        </p>
        <p class="policy-child-doc__p">
            （13）另外，当您使用相关功能时，我们还将使用这些权限：
        </p>
        <p class="policy-child-doc__p">
            • 定位权限：由于课程内容存在地域性，所以我们需要在您选择地区及添加地址时获取您的定位权限以更好为您展示课程。
        </p>
        <p class="policy-child-doc__p">
            • 跳转至其他app： 同时在某些场景需要添加老师微信和关注公众号时，为了您的操作流畅性，应用程序会跳转至相关微信小程序协助您更快捷便利地继续学习进程。
        </p>
        <p class="policy-child-doc__p">
            • 电话权限：为了进行设备检测及用户标识，我们需要电话权限获取您的设备ID。
        </p>
        <p class="policy-child-doc__p">
            • 陀螺仪权限：为了在拍照功能中识别手机翻转方向。本权限开启同时会获得您手机运动的信息。
        </p>
        <p class="policy-child-doc__p">
            • IP地址、GPS位置：查找和连接附近的可用硬件设备（硬件编程主控机、外接蓝牙键盘）等。
        </p>
        <p class="policy-child-doc__p">
            • 蓝牙信息：为您提供硬件编程所需各项服务（如获取硬件设备的距离、加速度传感器等信息）。
        </p>
        <p class="policy-child-doc__p">
            2、我们如何使用您的个人信息
        </p>
        <p class="policy-child-doc__p">
            对于必要的个人信息，我们会用来提供该项业务功能，我们也会使用上述信息来维护和改进本项业务功能，开发新的业务功能。
        </p>
        <p class="policy-child-doc__p">
            对于非必要的个人信息，我们会用于以下用途，包括：
        </p>
        <p class="policy-child-doc__p">
            （1）向您提供服务，保证您能正常使用我们的各个功能。
        </p>
        <p class="policy-child-doc__p">
            （2）产品开发和服务优化。例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。
        </p>
        <p class="policy-child-doc__p">
            （3）管理软件。例如，进行软件认证、软件升级。
        </p>
        <p class="policy-child-doc__p">
            （4）邀请您参与有关我们服务的调查。
        </p>
        <p class="policy-child-doc__p">
            3、我们如何委托处理、共享、转让、公开披露您的个人信息
        </p>
        <p class="policy-child-doc__p">
            （1）委托处理
        </p>
        <p class="policy-child-doc__p">
            本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。
        </p>
        <p class="policy-child-doc__p">
            （2）共享
        </p>
        <p class="policy-child-doc__p">
            GrowingIO SDK：收集您的设备信息（操作系统、设备型号、系统版本、AndroidID、IMEI、MAC地址）用于数据分析，从而改进我们的产品和服务。
        </p>
        <p class="policy-child-doc__p">
            （3）转让
        </p>
        <p class="policy-child-doc__p">
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：a) 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；b) 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
        </p>
        <p class="policy-child-doc__p">
            （4）公开披露
        </p>
        <p class="policy-child-doc__p">
            我们仅会在以下情形下，公开披露您的个人信息：a) 获得您明确同意后；b) 基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。
        </p>
        <p class="policy-child-doc__p">
            我们如何保护您的个人信息
        </p>
        <p class="policy-child-doc__p">
            （1）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
        </p>
        <p class="policy-child-doc__p">
            （2）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
        </p>
        <p class="policy-child-doc__p">
            （3）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </p>
        <p class="policy-child-doc__p">
            （4）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
        </p>
        <p class="policy-child-doc__p">
            4、我们如何使用 Cookie 和同类技术
        </p>
        <p class="policy-child-doc__p">
            “Cookie”是用作您计算机标识卡的计算机文件。我们或我们的第三方合作伙 伴，可能通过 cookies 收集和使用您的信息(包括:设备唯一标示、APP 版 本、登录鉴权 ID、三方统计 ID)，并将该等信息储存为日志信息。我们使用 cookies 目的是为识别您的身份，帮您省去重复输入注册信息的步骤，或者帮助判断您的帐号安全状态。我们可能会通过 cookies 收集非个人身份信息。如果您的浏览器或浏览器附加服务允许，您可以修改对 Cookie 的接受程度或者拒绝毛豆系列应用的 Cookie，请您理解，我们的某些服务只能通过使用 Cookie 才可得到实现。
        </p>
        <p class="policy-child-doc__p">
            第三方SDK调用说明
        </p>
        <p class="policy-child-doc__p">
            为保障毛豆系列应用产品App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。 我们对接入的相关第三方SDK在目录中列明。
        </p>
        <p class="policy-child-doc__p">
            第三方SDK目录（Android）
        </p>
        <p class="policy-child-doc__p">
            （1）Alipay（支付宝）
        </p>
        <p class="policy-child-doc__p">
            使用目的：帮助用户在应用内使用支付宝支付，并提高支付环境的安全性。
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：
        </p>
        <p class="policy-child-doc__p">
            数据类型:设备识别信息 (如IMEI、Android ID、IMSI、ICCID、OAID、MAC地址)、地理位置信息、运行中进程信息、wifi信息、传感器列表、BSSID、SSID、IP地址
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://render.alipay.com/p/c/k2h4n8ug" target="_blank" rel="noopener noreferrer">https://render.alipay.com/p/c/k2h4n8ug</a>
        </p>
        <p class="policy-child-doc__p">
            （2）微信开放SDK（包名：com.tencent.mm.opensdk、com.tencent.bugly、com.tencent.bugly(Bugly)）
        </p>
        <p class="policy-child-doc__p">
            使用目的：支持微信授权登录、微信分享和微信支付，并提高支付环境的安全性。
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、已安装app信息、Android id、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl" target="_blank" rel="noopener noreferrer">https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</a>
        </p>
        <p class="policy-child-doc__p">
            （3）闪验、创蓝云智（包名：com.chuanglan 、cn.com.chinatelecom、com.chuanglan.shanyan_sdk）
        </p>
        <p class="policy-child-doc__p">
            sdk其他名称：chuanglan-sms-operator 、天翼认证
        </p>
        <p class="policy-child-doc__p">
            使用目的：手机一键登录
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：IP地址、网卡（MAC地址）、国际移动设备识别码（IMEI）、OAID（替代IMEI）、sim卡信息，手机机型、系统类型、系统版本、网络环境、网关取号报错日志、已安装app信息、运行中进程信息、MAC、Android id、软件安装列表、获取MAC地址
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://tensdk.com/commit-detail/rcc5zd/fd21s8" target="_blank" rel="noopener noreferrer">https://tensdk.com/commit-detail/rcc5zd/fd21s8</a>
        </p>
        <p class="policy-child-doc__p">
            （4）腾讯x5 webview内核
        </p>
        <p class="policy-child-doc__p">
            使用目的：展示网页
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：无
        </p>
        <p class="policy-child-doc__p">
            收集方式：无
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://x5.tencent.com/tbs/guide/develop.html#5" target="_blank" rel="noopener noreferrer">https://x5.tencent.com/tbs/guide/develop.html#5</a>
        </p>
        <p class="policy-child-doc__p">
            （5）移动智能设备标识公共服务平台-统一SDK（包名：com.bun.miitmdid、com.zui.opendeviceidlibrary、com.bun）
        </p>
        <p class="policy-child-doc__p">
            使用目的：投放归因
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：IP地址、网卡（MAC地址）、国际移动设备识别码（IMEI）、OAID（替代IMEI）、Android id、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：本机采集，接口上报，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="http://msa-alliance.cn/col.jsp?id=120" target="_blank" rel="noopener noreferrer">http://msa-alliance.cn/col.jsp?id=120</a>
        </p>
        <p class="policy-child-doc__p">
            （6）阿里云OSS SDK（包名：com.aliyun）
        </p>
        <p class="policy-child-doc__p">
            使用目的：保存用户作品
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：无
        </p>
        <p class="policy-child-doc__p">
            收集方式：无
        </p>
        <p class="policy-child-doc__p">
            隐私权政策链接：<a class="policy-child-doc__link" href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.0.0.3fc85ff28enogr" target="_blank" rel="noopener noreferrer">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.0.0.3fc85ff28enogr</a>
        </p>
        <p class="policy-child-doc__p">
            （7）Growingio（com.growingio、com.growingio.android、com.growingio.eventcenter）
        </p>
        <p class="policy-child-doc__p">
            使用目的：上报埋点日志
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：操作系统、设备型号、系统版本、Android ID、IMEI、MAC地址、用户在app内的浏览、点击行为数据、运行中进程信息、粘贴板信息、软件安装列表、OAID
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            隐私权政策链接：<a class="policy-child-doc__link" href="https://accounts.growingio.com/privacy" target="_blank" rel="noopener noreferrer">https://accounts.growingio.com/privacy</a>
        </p>
        <p class="policy-child-doc__p">
            （8）推送SDK
        </p>
        <p class="policy-child-doc__p">
            SDK名称：腾讯移动推送 TPNS SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：消息推送
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：厂商、机型、通知栏开关状态、网络状态、第三方版本、系统语言、安卓系统版本、时区、设备分辨率、网络类型、设备启动时间、设备名称、国家编码、运营商代代号ram、rom、SD卡容量、crash时包含本身SDK的堆栈；设备信息(手机型号，系统类型、系统版本等)、网络信息(网络类型)、Android id、MAC地址、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            数据处理方式：通过去标识化、加密传输及其他安全方式
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            SDK名称：小米推送 SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：对小米品牌手机消息推送
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型： IMEI/OAID 编号、GAID 编号、IMSI 编号、MAC 地址、序列号、MIUI 版本及类型、ROM 版本、Android 版本、Android ID、Space ID、SIM 卡运营商和归属地、屏幕显示信息、设备输入信息、设备激活时间、设备制造商信息和型号名称、网络运营商、连接类型、硬件基础配置信息、销售渠道及使用相关信息（例如 CPU、内存、电量使用情况、设备分辨率、设备温度、相机镜头型号、亮屏次数和解锁次数）、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            SDK名称：华为推送 SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：对华为品牌手机消息推送
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-ios-0000001269116293" target="_blank" rel="noopener noreferrer">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-ios-0000001269116293</a>
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息，包含AppID，推送服务和HMS Core应用版本号、AppID，华为推送SDK版本号，应用版本号和应用包名、AAID和Push Token、设备类型（如手机，平板等）、设备型号、系统类型（如Android，HarmonyOS等）和系统版本、系统版本、国家码、Android id、MAC地址、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            SDK名称：OPPO 推送 SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：对 OPPO 品牌手机消息推送
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://open.oppomobile.com/new/developmentDoc/info?id=10288" target="_blank" rel="noopener noreferrer">https://open.oppomobile.com/new/developmentDoc/info?id=10288</a>
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型： IMEI/OAID 编号、GAID 编号、IMSI 编号、MAC 地址、序列号、MIUI 版本及类型、ROM 版本、Android 版本、Android ID、Space ID、SIM 卡运营商和归属地、屏幕显示信息、设备输入信息、设备激活时间、设备制造商信息和型号名称、网络运营商、连接类型、硬件基础配置信息、销售渠道及使用相关信息（例如 CPU、内存、电量使用情况、设备分辨率、设备温度、相机镜头型号、亮屏次数和解锁次数）、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            SDK名称：vivo 推送 SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：对 vivo 品牌手机消息推送
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://www.vivo.com.cn/about-vivo/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.vivo.com.cn/about-vivo/privacy-policy</a>
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：操作系统版本号、应用程序信息（包括应用安装列表）、设备标识符（如IMEI、ICCID 、EMMCID/UFSID 、oaid/vaid/aaid 、SN码 和 IMSI、android id、移动国家码和vivo Android设备的移动网号）、MAC地址、移动运营商、使用语言、系统设置等系统、设备和应用程序数据、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集
        </p>
        <p class="policy-child-doc__p">
            SDK名称：魅族推送 SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：对魅族品牌手机消息推送
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="http://static.meizu.com/resources/term/privacy8.html" target="_blank" rel="noopener noreferrer">http://static.meizu.com/resources/term/privacy8.html</a>
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：设备名称、设备型号、地区和语言设置、设备识别码（IMEI、OAID、IMSI）、设备硬件信息与状态、使用习惯、IP 地址、Mac 地址、操作系统版本，以及用于访问服务的设备的设置信息、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            （9）Byted Effect SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：录制视频，帮助用户合成作品
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://www.volcengine.com/docs/6256/64902" target="_blank" rel="noopener noreferrer">https://www.volcengine.com/docs/6256/64902</a>
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型： IMEI/OAID 编号、GAID 编号、IMSI 编号、MAC 地址、序列号、MIUI 版本及类型、ROM 版本、Android 版本、Android ID、Space ID、MAC地址、SIM 卡运营商和归属地、屏幕显示信息、设备输入信息、设备激活时间、设备制造商信息和型号名称、网络运营商、连接类型、硬件基础配置信息、销售渠道及使用相关信息（例如 CPU、内存、电量使用情况、设备分辨率、设备温度、相机镜头型号、亮屏次数和解锁次数）、软件安装列表
        </p>
        <p class="policy-child-doc__p">
            收集方式：无
        </p>
        <p class="policy-child-doc__p">
            （10）友盟+SDK（包名：com.uc.crashsdk、com.efs、com.umeng）
        </p>
        <p class="policy-child-doc__p">
            使用目的：收集使用崩溃信息
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：设备信息（IMEI/MAC/Android_ID/OpenUDID/GUID/SIM卡IMSI/地理位置）、运⾏中进程信息、已安装APP信息、设备序列号、Android ID、MAC地址、软件安装列表、获取IMSI信息、获取IMEI信息、获取ICCID、获取SN信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            （11） Logan 日志收集
        </p>
        <p class="policy-child-doc__p">
            使用目的：收集使用信息
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：设备信息（IMEI/MAC/Android ID/OpenUDID/GUID/SIM卡IMSI/地理位置）、运⾏中进程信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            官网链接：<a class="policy-child-doc__link" href="https://github.com/Meituan-Dianping/Logan" target="_blank" rel="noopener noreferrer">https://github.com/Meituan-Dianping/Logan</a>
        </p>
        <p class="policy-child-doc__p">
            （12） 讯飞 SDK（com.iflytek）
        </p>
        <p class="policy-child-doc__p">
            使用目的：用于进行语音评测
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID（安卓唯一设备ID以提供能力授权服务）、中国移动UAID（仅限安卓设备）、OAID（仅限安卓设备）、UUID（仅限iOS设备）、mac地址（仅限Linux设备）
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://www.xfyun.cn/doc/policy/privacy.html" target="_blank" rel="noopener noreferrer">https://www.xfyun.cn/doc/policy/privacy.html</a>
        </p>
        <p class="policy-child-doc__p">
            （13）小米SDK、小米集团SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：收集用户信息，为终端用户提供登陆功能、支付功能
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：SD卡数据、IMEI、Android ID、MAC
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            隐私权政策链接：<a class="policy-child-doc__link" href="https://dev.mi.com/distribute/doc/details?pId=1327" target="_blank" rel="noopener noreferrer">https://dev.mi.com/distribute/doc/details?pId=1327</a>
        </p>
        <p class="policy-child-doc__p">
            （14） 欢支付
        </p>
        <p class="policy-child-doc__p">
            基于支付渠道目的共享个人信息给广州欢网科技有限责任公司，共享的信息为统计级、匿名化数据，无法识别到用户个人。
        </p>
        <p class="policy-child-doc__p">
            产品名：欢支付
        </p>
        <p class="policy-child-doc__p">
            公司名称：广州欢网科技有限责任公司
        </p>
        <p class="policy-child-doc__p">
            使用目的：大屏支付
        </p>
        <p class="policy-child-doc__p">
            收集的个人信息类型/字段：IP地址和设备mac地址
        </p>
        <p class="policy-child-doc__p">
            隐私政策：<a class="policy-child-doc__link" href="https://ottepg-moss.cedock.com/paysdk/payagreement.html" target="_blank" rel="noopener noreferrer">https://ottepg-moss.cedock.com/paysdk/payagreement.html</a>
        </p>
        <p class="policy-child-doc__p">
            （15）转化SDK
        </p>
        <p class="policy-child-doc__p">
            SDK名称：转化SDK
        </p>
        <p class="policy-child-doc__p">
            开发者：北京巨量引擎网络技术有限公司
        </p>
        <p class="policy-child-doc__p">
            收集信息范围：设备标识符（IMEI/AndroidID/MAC/OAID/IDFV/IDFA/硬件序列号/IMSI/MEID)、设备信息（手机型号/手机厂商/系统版本）、位置信息、IP地址、设备传感器数据、运营商信息
        </p>
        <p class="policy-child-doc__p">
            使用目的：广告投放及数据监测、上报
        </p>
        <p class="policy-child-doc__p">
            SDK隐私政策链接：<a class="policy-child-doc__link" href="https://open.oceanengine.com/labels/8/docs/1708428054592516" target="_blank" rel="noopener noreferrer">https://open.oceanengine.com/labels/8/docs/1708428054592516</a>
        </p>
        <p class="policy-child-doc__p">
            （16）高德定位sdk
        </p>
        <p class="policy-child-doc__p">
            使用目的：实现定位
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备识别信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC 地址、OAID、IMSI、ICCID）、地理位置信息、wifi信息、BSSID、SSID、加速度传感器、压力传感器、旋转矢量传感器、传感器列表、硬件序列号
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://lbs.amap.com/home/privacy/" target="_blank" rel="noopener noreferrer">https://lbs.amap.com/home/privacy/</a>
        </p>
        <p class="policy-child-doc__p">
            （17）数字联盟可信ID SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：安全风控
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备基本情况信息，包括设备制造商、设备型号、设备状态、设备系统版本、应用版本、传感器（光传感器、磁场传感器、重力传感器、压力传感器、方向传感器、旋转矢量传感器、陀螺仪传感器、加速度传感器）、应用信息、通信状态、信号强度、蓝牙信息、设备网络状态信息【包括网络的接入形式、IP地址、WIFI信息（BSSID、SSID）、运营商类型及网络基站信息】、设备物理环境信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：本机采集
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://www.shuzilm.cn/privacy.html" target="_blank" rel="noopener noreferrer">https://www.shuzilm.cn/privacy.html</a>
        </p>
        <p class="policy-child-doc__p">
            第三方SDK目录（iOS）
        </p>
        <p class="policy-child-doc__p">
            （1）闪验
        </p>
        <p class="policy-child-doc__p">
            使用目的：手机一键登录
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备手机号，运营商信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://tensdk.com/commit-detail/rcc5zd/fd21s8" target="_blank" rel="noopener noreferrer">https://tensdk.com/commit-detail/rcc5zd/fd21s8</a>
        </p>
        <p class="policy-child-doc__p">
            （2）听云sdk
        </p>
        <p class="policy-child-doc__p">
            使用目的：收集使用崩溃信息
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备识别信息、客户端运行日志
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://www.tingyun.com/legal-declaration" target="_blank" rel="noopener noreferrer">https://www.tingyun.com/legal-declaration</a>
        </p>
        <p class="policy-child-doc__p">
            （3）友盟sdk
        </p>
        <p class="policy-child-doc__p">
            使用目的：收集使用崩溃信息
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备识别信息、客户端运行日志
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            （4）阿里OSS SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：保存用户作品
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：无
        </p>
        <p class="policy-child-doc__p">
            收集方式：无
        </p>
        <p class="policy-child-doc__p">
            隐私权政策链接：<a class="policy-child-doc__link" href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.0.0.3fc85ff28enogr" target="_blank" rel="noopener noreferrer">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.0.0.3fc85ff28enogr</a>
        </p>
        <p class="policy-child-doc__p">
            （5）Growingio
        </p>
        <p class="policy-child-doc__p">
            使用目的：上报埋点日志
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：用户在app内的浏览、点击行为数据
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            隐私权政策链接：<a class="policy-child-doc__link" href="https://accounts.growingio.com/privacy" target="_blank" rel="noopener noreferrer">https://accounts.growingio.com/privacy</a>
        </p>
        <p class="policy-child-doc__p">
            （6）Byted Effect SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：录制视频，帮助用户合成作品
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：不会收集个人信息，仅做图像处理
        </p>
        <p class="policy-child-doc__p">
            收集方式：无
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://www.volcengine.com/docs/6256/64902" target="_blank" rel="noopener noreferrer">https://www.volcengine.com/docs/6256/64902</a>
        </p>
        <p class="policy-child-doc__p">
            （7）推送SDK
        </p>
        <p class="policy-child-doc__p">
            SDK名称：腾讯移动推送 TPNS SDK
        </p>
        <p class="policy-child-doc__p">
            SDK用途：消息推送
        </p>
        <p class="policy-child-doc__p">
            收集个人信息类型：设备信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集，不涉及共享
        </p>
        <p class="policy-child-doc__p">
            隐私政策链接：<a class="policy-child-doc__link" href="https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b" target="_blank" rel="noopener noreferrer">https://privacy.qq.com/document/priview/bdf936b2477a45ff86da57e3d988bc2b</a>
        </p>
        <p class="policy-child-doc__p">
            （8）高德定位sdk
        </p>
        <p class="policy-child-doc__p">
            使用目的：实现定位
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备识别信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC 地址、OAID、IMSI、ICCID）、地理位置信息、wifi信息、BSSID、SSID、加速度传感器、压力传感器、旋转矢量传感器、传感器列表、硬件序列号
        </p>
        <p class="policy-child-doc__p">
            收集方式：SDK本机采集
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://lbs.amap.com/home/privacy/" target="_blank" rel="noopener noreferrer">https://lbs.amap.com/home/privacy/</a>
        </p>
        <p class="policy-child-doc__p">
            （9）数字联盟可信ID SDK
        </p>
        <p class="policy-child-doc__p">
            使用目的：安全风控
        </p>
        <p class="policy-child-doc__p">
            收集数据类型：设备基本情况信息，包括设备制造商、设备型号、设备状态、设备系统版本、应用版本、传感器（光传感器、磁场传感器、重力传感器、压力传感器、方向传感器、旋转矢量传感器、陀螺仪传感器、加速度传感器）、应用信息、通信状态、信号强度、蓝牙信息、设备网络状态信息【包括网络的接入形式、IP地址、WIFI信息（BSSID、SSID）、运营商类型及网络基站信息】、设备物理环境信息
        </p>
        <p class="policy-child-doc__p">
            收集方式：本机采集
        </p>
        <p class="policy-child-doc__p">
            第三方隐私权政策链接：<a class="policy-child-doc__link" href="https://www.shuzilm.cn/privacy.html" target="_blank" rel="noopener noreferrer">https://www.shuzilm.cn/privacy.html</a>
        </p>
        <p class="policy-child-doc__p">
            您的权利
        </p>
        <p class="policy-child-doc__p">
            按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        </p>
        <p class="policy-child-doc__p">
            （1）查询您的个人信息
        </p>
        <p class="policy-child-doc__p">
            您有权查询您的个人信息，法律法规规定的例外情况除外。
        </p>
        <p class="policy-child-doc__p">
            对于您在使用我们的产品或服务过程中产生的信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权， 请发送电子邮件至 ：xuelu@gaotu.cn
        </p>
        <p class="policy-child-doc__p">
            我们将在15个工作日内回复您的查询请求。
        </p>
        <p class="policy-child-doc__p">
            （2）更正您的个人信息
        </p>
        <p class="policy-child-doc__p">
            当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。您可以通过“（1）访问您的个人信息”中罗列的方式提出更正申请。如果您无法通过上述链接更正这些个人信息，您可以随时发送电子邮件
        </p>
        <p class="policy-child-doc__p">
            我们将在15个工作日内回复您的更正请求。
        </p>
        <p class="policy-child-doc__p">
            （3）删除您的个人信息
        </p>
        <p class="policy-child-doc__p">
            在以下情形中，您可以向我们提出删除个人信息的请求：
        </p>
        <p class="policy-child-doc__p">
            • 如果我们处理个人信息的行为违反法律法规；
        </p>
        <p class="policy-child-doc__p">
            • 如果我们收集、使用您的个人信息，却未征得您的同意；
        </p>
        <p class="policy-child-doc__p">
            • 如果我们处理个人信息的行为违反了与您的约定；
        </p>
        <p class="policy-child-doc__p">
            • 如果您不再使用我们的产品或服务，或您注销了账号；
        </p>
        <p class="policy-child-doc__p">
            • 如果我们不再为您提供产品或服务。
        </p>
        <p class="policy-child-doc__p">
            若我们决定响应您的删除请求，我们还将同时通知从我们获得的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统 中删除相应的信息，但会在备份更新时删除这些信息。
        </p>
        <p class="policy-child-doc__p">
            我们将在15个工作日内回复您的删除请求。
        </p>
        <p class="policy-child-doc__p">
            （4）改变您授权同意的范围
        </p>
        <p class="policy-child-doc__p">
            每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </p>
        <p class="policy-child-doc__p">
            （5）个人信息主体注销账户
        </p>
        <p class="policy-child-doc__p">
            您随时可注销此前注册的账户，您可以联系此电话进行申请：4000910188
        </p>
        <p class="policy-child-doc__p">
            我们会在15个工作日内对您的申请进行受理，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。
        </p>
        <p class="policy-child-doc__p">
            （6）撤回授权您的个人信息
        </p>
        <p class="policy-child-doc__p">
            部分个人信息是使用我们服务所必需的，但大多数其他个人信息的提供是由您决定的。您可以通过修改个人设置、删除相关信息等方式撤回部分授权，也可以通过关闭功能的方式撤销授权。您可以电话联系客服（电话服务渠道：4000-910-188）向我们提出撤回对于隐私政策协议内容的同意授权。当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理，我们会在15个工作日内响应、做出答复或合理解释。
        </p>
        <p class="policy-child-doc__p">
            （7）个人信息主体获取个人信息副本
        </p>
        <p class="policy-child-doc__p">
            您有权获取您的个人信息副本，您可以通过以下方式自行操作：……
        </p>
        <p class="policy-child-doc__p">
            在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
        </p>
        <p class="policy-child-doc__p">
            （8）约束信息系统自动决策
        </p>
        <p class="policy-child-doc__p">
            在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。
        </p>
        <p class="policy-child-doc__p">
            （9）响应您的上述请求
        </p>
        <p class="policy-child-doc__p">
            为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在15个工作日内作出答复。
        </p>
        <p class="policy-child-doc__p">
            对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
        </p>
        <p class="policy-child-doc__p">
            在以下情形中，我们将无法响应您的请求：
        </p>
        <p class="policy-child-doc__p">
            • 与个人信息控制者履行法律法规规定的义务相关的；
        </p>
        <p class="policy-child-doc__p">
            • 与国家安全、国防安全直接相关的；
        </p>
        <p class="policy-child-doc__p">
            • 与公共安全、公共卫生、重大公共利益直接相关的；
        </p>
        <p class="policy-child-doc__p">
            • 与刑事侦查、起诉、审判和执行判决等直接相关的；
        </p>
        <p class="policy-child-doc__p">
            • 个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；
        </p>
        <p class="policy-child-doc__p">
            • 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p class="policy-child-doc__p">
            • 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的； 涉及商业秘密的。
        </p>
        <p class="policy-child-doc__p">
            我们如何处理儿童的个人信息
        </p>
        <p class="policy-child-doc__p">
            我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的个人信息主体账户。
        </p>
        <p class="policy-child-doc__p">
            对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        </p>
        <p class="policy-child-doc__p">
            尽管当地法律和习俗对儿童的定义不同，但我们将不满 14周岁的任何人均视为儿童。
        </p>
        <p class="policy-child-doc__p">
            如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
        </p>
        <p class="policy-child-doc__p">
            您的个人信息如何在全球范围转移
        </p>
        <p class="policy-child-doc__p">
            原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。
        </p>
        <p class="policy-child-doc__p">
            本政策如何更新
        </p>
        <p class="policy-child-doc__p">
            我们的个人信息保护政策可能变更。
        </p>
        <p class="policy-child-doc__p">
            未经您明确同意，我们不会削减您按照本个人信息保护政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
        </p>
        <p class="policy-child-doc__p">
            对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件或应用内弹窗发送通知，说明个人信息保护政策的具体变更内容）。
        </p>
        <p class="policy-child-doc__p">
            本政策所指的重大变更包括但不限于：
        </p>
        <p class="policy-child-doc__p">
            1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
        </p>
        <p class="policy-child-doc__p">
            2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
        </p>
        <p class="policy-child-doc__p">
            3、个人信息共享、转让或公开披露的主要对象发生变化；
        </p>
        <p class="policy-child-doc__p">
            4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
        </p>
        <p class="policy-child-doc__p">
            5、我们负责处理个人信息安全的责任部门、联络方式及投诉 渠道发生变化时；
        </p>
        <p class="policy-child-doc__p">
            6、个人信息安全影响评估报告表明存在高风险时。我们还会将本政策的旧版本存档，供您查阅。
        </p>
        <p class="policy-child-doc__p">
            如何联系我们
        </p>
        <p class="policy-child-doc__p">
            如果您对本个人信息保护政策有任何疑问、意见或建议，通过以下方式与我们联系：xuelu@gaotu.cn 一般情况下，我们将在15个工作日内回复。
        </p>
        <p class="policy-child-doc__p">
            如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：向北京市海淀区人民法院提起诉讼。
        </p>
    </div>
</template>

<script>
export default {
    name: 'PersonalInfoPolicy20260507Content',
};
</script>
